const EmptyReport = () => import('../components/reports/EmptyReports.vue');
const AiReports = () => import('../components/reports/AiReports.vue');

const reports = {
    path: '/reportes',
    meta: {
        requiresAuth: true
    },
    component: EmptyReport,
    children: [
        { path: 'ia', component: AiReports, name: 'AiReports', meta: { title: 'Reportes con IA' } },
    ],
};

export default reports;
